import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAddOrderCardType as _getAddOrderCardType, getOrderInfo as _getOrderInfo, editOrder as _editOrder, getSyncOpportunity, getOrderRuleList as _getOrderRuleList, checkOrderDiscount, getAddOrderChannelList as _getAddOrderChannelList, getChannelList as _getChannelList, getContactByCustomerId as _getContactByCustomerId } from '@/api/order';
import { getSellUsers } from '@/api/user';
import { addSaleProjectDelivery } from '@/views/cardSystem/saleToos/api';
import { getOpportunityInfo as _getOpportunityInfo } from '@/views/schemeManage/data';
export default {
  name: 'SaleCreateOrder',
  props: {
    isDrawer: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    },
    saleProjectDeliveryId: {
      type: [String, Number],
      default: null
    },
    editFlag: {
      type: [String, Number],
      default: 0
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      edit: 0,
      // 0 新建 1 编辑
      submitLoading: false,
      // 防提交
      input: '',
      brandList: [],
      cardTypeList: [],
      // 卡类型数据
      opportunityList: [],
      // 商机
      sendStatus: '0',
      // 判断是否是sass 用户
      disabledFlag: false,
      // 其中判断创建不可编辑，编辑是可修改卡名称
      couponFlag: false,
      // 搭售优惠券
      can_up: false,
      // 0 不编辑 1 编辑
      infoLoading: false,
      sendTypeList: [{
        id: 1,
        name: '实体卡/券'
      }, {
        id: 2,
        name: '虚拟卡/券'
      }, {
        id: 3,
        name: '电子码(导出Excel)'
      }],
      // 发放类型
      saleTypes: [{
        id: 0,
        name: '售卡'
      }, {
        id: 4,
        name: '数据迁移'
      }],
      // 售卡类型
      special_brands: [],
      // 特殊品牌
      special_menus: [],
      // 特殊菜单
      max_goods_points: 0,
      // 电影次卡的消费上限
      commission: '',
      // 佣金
      sellUserList: [],
      // 销售人员列表
      ruleForm: {
        sale_type: 0,
        card_bin_group_id: '',
        // 业务类型id
        card_bin_id: '',
        // 卡类型id
        contact_id: '',
        // 联系人姓名id
        contact_mobile: '',
        // 联系人手机号
        card_name: '',
        // 卡名称
        customer_id: '',
        // 客户名称id
        user_opportunity_id: '',
        // 商机id
        opportunity_name: '',
        // 商机名称
        username: '',
        // 负责人
        the_loser_id: '',
        target_cost_rate: '',
        // 成本率目标（下单页不展示，仅回填与提交时透传）
        money: '',
        // 售卡金额
        discount: null,
        // 折扣
        total_points: '',
        // 售卡总点数
        service_cost: '',
        // 优惠券成本
        company_cost: '',
        // 服务成本
        remark: '',
        // 备注
        customer_type: null,
        order_card_sale_rule_id: '',
        order_delay_rule_id: '',
        send_type: null,
        // 发放类型
        diff_money: '',
        per_capita_budget: null,
        // 人均预算
        customers_num: '',
        // 确定客户人数
        amount: '',
        // 商机金额
        other_max_goods_points: '',
        // 积分兑换
        settlement_type: null,
        commission_type: null,
        is_return_money: 0,
        how_to_sell_cards: 1,
        diff_remark: ''
      },
      ruleForm1: {
        achievement: '',
        // 计入业绩
        sale_commision: '' // 佣金
      },
      empty: '',
      propertion: '',
      // 业绩增减比例
      propertion1: '',
      // 业绩增减比例
      nature: '',
      // 客户类型
      validRange: [],
      // 有效期范围
      inValidRange: [],
      // 失效期范围
      sycOppLoading: false,
      // 同步商机按钮状态
      channel_id: '',
      isChannel: true,
      send_type: -1,
      // 搭售优惠券用
      has_other_menus: -1,
      proxyCustomer: '',
      // 2代理客户
      companyList: [],
      confim_nature: '',
      orderInfo: {},
      showContect: false,
      mobileList: [],
      isOrderOpportunity: false,
      // 订单关联商机
      validAchievement: '',
      // 有效期业绩增减比例
      invalidAchievement: '' // 延期业绩增减比例
    };
  },
  computed: {
    addCard: function addCard() {
      var obj = {
        cardTotal: 0
      };
      if (Number(this.ruleForm.discount) === 0) {
        obj.cardTotal = 0;
      } else {
        if (this.ruleForm.money && this.ruleForm.discount) {
          var num = Number(this.ruleForm.money) / Number(this.ruleForm.discount) * 100 / 100;
          if (num >= 0) {
            this.ruleForm.card_bin_group_id === 4 ? obj.cardTotal = Math.floor(num) : obj.cardTotal = this.formatDecimal(num);
          }
        }
      }
      return obj;
    },
    cardTypeChannelList: function cardTypeChannelList() {
      return this.$store.state.user.cardTypeChannelList.filter(function (item) {
        return item.id !== 3;
      });
    } // totalMoney() {
    // 	var reg = /^\d{1,9}(\.\d{1,2})?$/
    // 	if (
    // 		reg.test(this.ruleForm.total_points) &&
    // 		reg.test(this.ruleForm.discount)
    // 	) {
    // 		return this.ruleForm.total_points * this.ruleForm.discount
    // 	}
    // }
  },
  watch: {
    'ruleForm.card_bin_group_id': function ruleFormCard_bin_group_id(val, old) {
      this.getAddOrderCardType();
    }
  },
  created: function created() {
    var _this = this;
    // 报价单下单入口按订单回填，客户名称改由回填后按客户名精确拉取，跳过这里的全量拉取
    var prefilledFromOrder = this.isDrawer && this.orderId && !this.editFlag;
    if (this.isDrawer && this.editFlag) {
      this.edit = Number(this.editFlag);
      this.disabledFlag = true;
      this.order_id = this.orderId;
      this.getOrderInfo();
    } else if (this.isDrawer && this.orderId) {
      // 抽屉内新建但携带订单号（报价单下单虚拟订单）：按订单号回填表单
      this.order_id = this.orderId;
      this.getOrderInfo().then(function () {
        // 客户名称下拉默认只返回前 500 条，按订单客户名补拉，否则回显成客户 id
        _this.getAddOrderChannelList(_this.orderInfo.customer_name || '');
        // 回填后主动拉取订单规则（有效期/延期范围仅在交互中触发，此处需补调）
        if (_this.ruleForm.card_bin_group_id && _this.ruleForm.customer_id) {
          _this.getOrderRuleList(_this.ruleForm.card_bin_group_id);
        }
      });
    } else if (this.$route.query.edit) {
      this.edit = Number(this.$route.query.edit);
      this.disabledFlag = true;
      this.order_id = this.$route.query.order_id;
      this.getOrderInfo();
    } else {
      this.getChannelList();
    }
    if (this.$route.query.send_type) {
      this.send_type = Number(this.$route.query.send_type);
      this.order_id = this.$route.query.order_id;
      this.couponFlag = true;
      this.getOrderInfo();
      this.getAddOrderChannelList(this.$route.query.customer_name);
    } else if (!prefilledFromOrder) {
      this.getAddOrderChannelList();
    }
    this.getSellUsersList();
  },
  methods: {
    changeSaleType: function changeSaleType(val) {
      var _this2 = this;
      if (val) {
        this.sendTypeList = [{
          id: 3,
          name: '电子码(导出Excel)'
        }];
        this.ruleForm.send_type = 3;
      } else {
        if (this.ruleForm.customer_id) {
          this.companyList.forEach(function (e) {
            if (_this2.ruleForm.customer_id == e.id) {
              _this2.sendTypeList = e.info.send_type;
            }
          });
        } else {
          this.sendTypeList = [{
            id: 1,
            name: '实体卡/券'
          }, {
            id: 2,
            name: '虚拟卡/券'
          }, {
            id: 3,
            name: '电子码(导出Excel)'
          }];
        }
        this.ruleForm.send_type = null;
      }
    },
    remoteMethod: function remoteMethod(val) {
      this.getAddOrderChannelList(val);
    },
    getChannelList: function getChannelList() {
      var _this3 = this;
      _getChannelList().then(function (res) {
        _this3.isChannel = parseInt(res.data.channel_id) === 1;
      });
    },
    getSellUsersList: function getSellUsersList() {
      var _this4 = this;
      var params = {
        type: 3
      };
      getSellUsers(params).then(function (res) {
        _this4.sellUserList = res.data.list.filter(function (item) {
          return Number(item.status) === 10;
        });
      });
    },
    getAddOrderChannelList: function getAddOrderChannelList(val) {
      var _this5 = this;
      var params = {
        page_size: 500,
        company_name: val || ''
      };
      _getAddOrderChannelList(params).then(function (res) {
        _this5.companyList = res.data.list;
      });
    },
    formatDecimal: function formatDecimal(n) {
      var r = Math.round(n * 100) / 100; // 先四舍五入到分
      return r * 100 % 100 === 0 ? String(r | 0) : r.toFixed(2);
    },
    // 驳回订单
    // submitOrderAudit() {
    //   this.$confirm('是否将该订单驳回？?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.submitLoading = true
    //     const params = {
    //       order_id: this.order_id,
    //       audit_status: 2
    //     }
    //     orderAudit(params).then(() => {
    //       this.$router.back()
    //       this.$message.success('审核驳回')
    //     }).finally(() => {
    //       this.submitLoading = false
    //     })
    //   })
    // },
    // 返回上一页
    goBack: function goBack() {
      this.$router.back();
    },
    // 获取卡类型
    getAddOrderCardType: function getAddOrderCardType() {
      var _this6 = this;
      var params = {
        business_id: this.ruleForm.card_bin_group_id,
        create_order: 1
      };
      _getAddOrderCardType(params).then(function (res) {
        _this6.cardTypeList = res.data;
        if (_this6.ruleForm.card_bin_group_id == 4 && _this6.$route.query.edit) {
          _this6.cardTypeList.forEach(function (e) {
            if (_this6.ruleForm.card_bin_id == e.id) {
              _this6.max_goods_points = e.max_goods_points;
            }
          });
        }
      });
    },
    // 获取基本信息
    getOrderInfo: function getOrderInfo() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                order_id: _this7.order_id
              };
              _this7.infoLoading = true;
              return _context.a(2, _getOrderInfo(params).then(function (res) {
                _this7.orderInfo = res.data;
                // 搭售优惠券
                if (_this7.send_type === 4) {
                  res.data.card_bin_group_id = '';
                  res.data.card_bin_id = '';
                  res.data.card_name = '';
                  res.data.remark = '';
                  res.data.send_type.push({
                    name: '搭售',
                    id: 4
                  });
                  res.data.money = '';
                  res.data.discount = '';
                }
                _this7.sendTypeList = res.data.send_type;
                _this7.ruleForm = {
                  sale_type: 0,
                  // 售卡类型
                  card_bin_group_id: res.data.card_bin_group_id,
                  // 业务类型id
                  card_bin_id: res.data.card_bin_id,
                  // 卡类型id
                  card_name: res.data.card_name,
                  // 卡名称
                  customer_id: res.data.customer_id.toString(),
                  // 客户名称id
                  user_opportunity_id: res.data.user_opportunity_id,
                  // 商机id
                  opportunity_name: res.data.opportunity_name,
                  // 商机名称
                  username: res.data.username,
                  // 负责人
                  money: res.data.money,
                  // 售卡金额
                  discount: res.data.discount,
                  // 折扣
                  total_points: res.data.total_points,
                  // 售卡总点数
                  service_cost: res.data.service_cost.toString(),
                  // 优惠券成本
                  company_cost: res.data.company_cost.toString(),
                  // 服务成本
                  remark: res.data.remark,
                  // 备注
                  send_type: res.data.selected_send_type,
                  // 发放类型
                  per_capita_budget: res.data.per_capita_budget,
                  // 人均预算
                  customers_num: res.data.customers_num,
                  // 确定客户人数
                  amount: res.data.amount,
                  // 商机金额
                  diff_money: res.data.diff_money,
                  // 偏差金额
                  customer_type: res.data.confim_nature,
                  // 客户类型
                  settlement_type: res.data.settlement_type,
                  commission_type: res.data.commission_type,
                  // 佣金核算方式
                  is_return_money: res.data.is_return_money,
                  // 佣金核算方式
                  how_to_sell_cards: res.data.how_to_sell_cards || 1,
                  // 售卡方式
                  target_cost_rate: res.data.target_cost_rate,
                  // 成本率目标
                  the_loser_id: res.data.the_loser_id,
                  diff_remark: res.data.diff_remark
                };
                _this7.confim_nature = res.data.confim_nature;
                if (res.data.card_bin_group_id == 4 && _this7.edit) {
                  _this7.ruleForm.total_points = res.data.cika_total_points;
                }
                // 搭售优惠券
                if (_this7.send_type === 4) {
                  _this7.ruleForm.send_type = 4;
                } else {
                  _this7.ruleForm.send_type = res.data.selected_send_type;
                  _this7.can_up = res.data.can_up === 0;
                }
                _this7.special_brands = res.data.special_brands;
                _this7.special_menus = res.data.special_menus;
                res.data.order_rule.forEach(function (e) {
                  if (e.type == '1') {
                    // this.validRange.time = `${e.start_month_num} < 有效期范围 <= ${e.end_month_num}`
                    _this7.validAchievement = e.achievement;
                  }
                  if (e.type == '2') {
                    // this.invalidRange.time = `${e.start_month_num} < 延期范围 <= ${e.end_month_num}`
                    _this7.invalidAchievement = e.achievement;
                  }
                });
              }).finally(function () {
                _this7.infoLoading = false;
              }));
          }
        }, _callee);
      }))();
    },
    // 点击卡类型 获取默认卡名称
    changeCardType: function changeCardType(id) {
      var _this8 = this;
      this.cardTypeList.forEach(function (el) {
        if (el.id === id) {
          _this8.ruleForm.card_name = el.card_name;
          _this8.ruleForm.other_max_goods_points = el.other_max_goods_points;
          _this8.max_goods_points = el.max_goods_points;
          _this8.has_other_menus = el.has_other_menus;
        }
      });
    },
    // 点击客户名称获取负责人 及商机
    changeCustomer: function changeCustomer(id) {
      var _this9 = this;
      if (this.ruleForm.card_bin_group_id) {
        if (id) {
          this.getOrderRuleList(this.ruleForm.card_bin_group_id);
        }
      }
      if (id) {
        this.getOpportunityInfo(id);
        this.getContactByCustomerId(id);
      }
      this.companyList.forEach(function (el) {
        if (el.id === id) {
          _this9.proxyCustomer = el.info.sale_type;
          _this9.channel_id = el.info.channel_id;
          _this9.ruleForm.username = el.info.username;
          _this9.nature = el.info.nature;
          _this9.ruleForm.customer_type = el.info.confim_nature;
          _this9.confim_nature = el.info.confim_nature;
          // 数据迁移发放类型只有电子码  默认选中
          if (_this9.ruleForm.sale_type == 4) {
            var sendList = el.info.send_type.find(function (item) {
              return item.id == 3;
            });
            _this9.sendTypeList = [sendList];
            _this9.ruleForm.send_type = 3;
          } else {
            // 这期不让选虚拟卡
            el.info.status === '1' ? _this9.ruleForm.send_type = null : _this9.ruleForm.send_type = 1;
            _this9.sendTypeList = el.info.send_type;
          }
        }
      });
    },
    // 获取客户关联联系人
    getContactByCustomerId: function getContactByCustomerId(id) {
      var _this0 = this;
      this.ruleForm.contact_id = '';
      this.ruleForm.contact_mobile = '';
      this.contactsList = [];
      this.mobileList = [];
      this.showContect = false;
      _getContactByCustomerId({
        customer_id: id
      }).then(function (res) {
        // 客户级别 是否需要商机 0否1是2渠道级别
        if (res.data.customer_is_need_opportunity == 1) {
          _this0.isOrderOpportunity = true;
          // 客户应用渠道配置并且开启了关联
        } else if ((res.data.customer_is_need_opportunity == 2 || res.data.customer_is_need_opportunity === '') && res.data.channel_is_need_opportunity == 1) {
          _this0.isOrderOpportunity = true;
        }
        // 客户开启直接展示
        if (res.data.add_customer_config == 1 && res.data.user_need_contact) {
          _this0.showContect = true;
          _this0.contactsList = res.data.contacts;
          // 客户应用渠道配置并且开启了关联
        } else if ((res.data.add_customer_config == 2 || res.data.add_customer_config === '') && res.data.add_channel_config == 1 && res.data.user_need_contact) {
          _this0.showContect = true;
          _this0.contactsList = res.data.contacts;
        }
      });
    },
    // 切换联系人
    changeContact: function changeContact(id) {
      var _this1 = this;
      this.mobileList = [];
      this.ruleForm.contact_mobile = '';
      this.contactsList.forEach(function (e) {
        if (id == e.id) {
          if (e.mobile) {
            _this1.mobileList.push({
              mobile: e.mobile,
              mobile_str: e.mobile_str
            });
          }
          if (e.tel2) {
            _this1.mobileList.push({
              mobile: e.tel2,
              mobile_str: e.tel2_str
            });
          }
          if (e.tel3) {
            _this1.mobileList.push({
              mobile: e.tel3,
              mobile_str: e.tel3_str
            });
          }
        }
      });
    },
    getOpportunityInfo: function getOpportunityInfo(id) {
      var _this10 = this;
      _getOpportunityInfo({
        customer_id: id,
        create_order: 1,
        card_bin_group_id: this.ruleForm.card_bin_group_id || 0
      }).then(function (res) {
        if (_this10.send_type != 4) {
          _this10.opportunityList = res.data.list;
          _this10.ruleForm.user_opportunity_id = '';
        }
      });
    },
    // 修改单价
    changeDiscount: function changeDiscount() {
      // if (this.has_other_menus === 1) {
      // 	this.ruleForm.other_max_goods_points = this.ruleForm.discount
      // }
    },
    // 切换商机
    changeOpportunity: function changeOpportunity(val) {
      var _this11 = this;
      this.opportunityList.forEach(function (el) {
        if (el.id === val) {
          _this11.ruleForm.per_capita_budget = el.info.per_capita_budget;
          _this11.ruleForm.customers_num = el.info.customers_num;
          _this11.ruleForm.amount = el.info.amount;
        }
      });
    },
    // 切换业务类型
    changeCardRadio: function changeCardRadio(val) {
      this.ruleForm.card_bin_id = '';
      this.ruleForm.card_name = '';
      this.addCard.cardTotal = 0;
      this.ruleForm.money = '';
      this.ruleForm.discount = null;
      this.validRange = [];
      this.inValidRange = [];
      this.ruleForm.order_card_sale_rule_id = '';
      this.ruleForm.order_delay_rule_id = '';
      this.propertion = '';
      this.propertion1 = '';
      if (this.ruleForm.customer_id) {
        this.getOpportunityInfo(this.ruleForm.customer_id);
        this.getOrderRuleList(val);
      }
    },
    // 获取订单规则
    getOrderRuleList: function getOrderRuleList(val) {
      var _this12 = this;
      this.validRange = [];
      this.inValidRange = [];
      this.ruleForm.order_card_sale_rule_id = '';
      this.ruleForm.order_delay_rule_id = '';
      _getOrderRuleList({
        card_bin_group_id: val,
        customer_id: this.ruleForm.customer_id,
        is_create_order: 1
      }).then(function (res) {
        res.data.forEach(function (e) {
          if (e.type === '1') {
            // e.name = `${e.start_month_num} < 有效期范围 <= ${e.end_month_num}`
            e.name = e.explain;
            _this12.validRange.push(e);
          }
          if (e.type === '2') {
            // e.name = `${e.start_month_num} < 延期范围 <= ${e.end_month_num}`
            e.name = e.explain;
            _this12.inValidRange.push(e);
          }
        });
        if (_this12.validRange.length) {
          _this12.validRange.some(function (e) {
            if (e.is_default === '1') {
              _this12.ruleForm.order_card_sale_rule_id = e.id;
              return true;
            }
          });
          if (_this12.defaultFlag(_this12.validRange)) {
            _this12.ruleForm.order_card_sale_rule_id = '';
          }
          _this12.changeRange(1);
        }
        // 设置第一项有默认值的赋值
        if (_this12.inValidRange.length) {
          _this12.inValidRange.some(function (e) {
            if (e.is_default === '1') {
              _this12.ruleForm.order_delay_rule_id = e.id;
              return true;
            }
          });
          if (_this12.defaultFlag(_this12.inValidRange)) {
            _this12.ruleForm.order_delay_rule_id = '';
          }
          _this12.changeRange(2);
        }
      });
    },
    // 没有设置default 置空
    defaultFlag: function defaultFlag(data) {
      return data.every(function (el) {
        if (el.is_default === '0') {
          return true;
        }
      });
    },
    // 切换有效期范围
    changeRange: function changeRange(val) {
      var _this13 = this;
      if (val === 1) {
        this.validRange.forEach(function (e) {
          if (e.id === _this13.ruleForm.order_card_sale_rule_id) {
            _this13.propertion = e.achievement;
          }
        });
      } else {
        this.inValidRange.forEach(function (e) {
          if (e.id === _this13.ruleForm.order_delay_rule_id) {
            _this13.propertion1 = e.achievement;
          }
        });
      }
    },
    // 折扣范围 0 -1
    blurDiscount: function blurDiscount() {
      var reg = /^\d{1,9}(\.\d{1,3})?$/;
      if (this.send_type === 4) {
        //  搭售
        if (this.ruleForm.discount > 1 || this.ruleForm.discount < 0 || !reg.test(this.ruleForm.discount)) {
          this.$message.warning('请填写 0 -1 范围之间，支持三位小数');
          this.ruleForm.discount = undefined;
        }
      } else {
        if (this.ruleForm.discount > 1 || this.ruleForm.discount <= 0 || !reg.test(this.ruleForm.discount)) {
          this.$message.warning('请填写 0 -1 范围之间，支持三位小数');
          this.ruleForm.discount = undefined;
        }
      }
    },
    // 提交订单
    submitOrder: function submitOrder() {
      var _this14 = this;
      var forms = [this.$refs.ruleForm, this.$refs.formBoxForm];
      var validCount = 0;
      var hasInvalid = false;
      var checkAllValid = function checkAllValid() {
        validCount++;
        if (hasInvalid || validCount < forms.length) return;
        if (_this14.orderInfo.create_commission == 1 && _this14.ruleForm.commission_type == 1) {
          _this14.$message.error('已达成订单不可将佣金核算状态修改为人工未核算');
          return false;
        }
        _this14.submitLoading = true;
        if (_this14.orderInfo.audit_status == 5) {
          _this14.$confirm('<span style="color: red">订单已确认，请核实修改后回款/应收/业绩是否有影响！</span>', '编辑订单', {
            confirmButtonText: '保存',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(function () {
            _this14.edit === 0 || _this14.edit === 3 ? _this14.createOrder() : _this14.editOrder();
          });
        } else {
          _this14.edit === 0 || _this14.edit === 3 ? _this14.createOrder() : _this14.editOrder();
        }
      };
      forms.forEach(function (form) {
        form.validate(function (valid) {
          if (valid) {
            checkAllValid();
          } else {
            hasInvalid = true;
            _this14.submitLoading = false;
            console.log('error submit!!');
            return false;
          }
        });
      });
    },
    // 同步商机
    sycOpp: function sycOpp() {
      var _this15 = this;
      this.sycOppLoading = true;
      getSyncOpportunity().then(function (res) {
        _this15.$message.success('同步成功');
      }).catch(function () {
        _this15.$message.success('同步失败');
      }).finally(function () {
        _this15.sycOppLoading = false;
      });
    },
    // 创建订单
    createOrder: function createOrder() {
      var _this16 = this;
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.customer_type == undefined || this.ruleForm.customer_type == '' || this.ruleForm.customer_type == 0) {
        this.$message.error('请选择客户类型');
        this.submitLoading = false;
        return false;
      }
      if (this.send_type === 4) {
        checkOrderDiscount({
          card_bin_group_id: this.ruleForm.card_bin_group_id,
          discount: this.ruleForm.discount,
          send_type: this.ruleForm.send_type,
          card_bin_id: this.ruleForm.card_bin_id
        }).then(function (res) {
          if (res.data.has_proportion === 0) {
            _this16.dialogVisible = true;
            _this16.submitLoading = false;
          } else {
            _this16.addOrder();
          }
        });
      } else {
        this.addOrder();
      }
    },
    addOrder: function addOrder(flag) {
      var _this17 = this;
      var params = _objectSpread({}, this.ruleForm);
      params.target_cost_rate = params.the_loser_id ? params.target_cost_rate : '';
      // 报价单下单：提交虚拟订单号与申请单 id，走独立的下单保存接口
      params.order_id = this.order_id;
      params.sale_project_delivery_id = this.saleProjectDeliveryId;
      if (flag) {
        this.$refs.ruleForm1.validate(function (valid) {
          if (valid) {
            _this17.submitLoading = true;
            addSaleProjectDelivery(_objectSpread(_objectSpread({}, params), _this17.ruleForm1)).then(function (res) {
              _this17.$message.success('创建成功');
              _this17.dialogVisible = false;
              if (_this17.isDrawer) {
                _this17.$emit('onSuccess');
              } else {
                _this17.$router.go(-1);
              }
            }).finally(function () {
              _this17.submitLoading = false;
            });
          } else {
            _this17.submitLoading = false;
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.submitLoading = true;
        addSaleProjectDelivery(params).then(function (res) {
          _this17.submitLoading = false;
          _this17.$message.success('创建成功');
          if (_this17.isDrawer) {
            _this17.$emit('onSuccess');
          } else {
            _this17.$router.go(-1);
          }
        }).finally(function () {
          _this17.submitLoading = false;
        });
      }
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.ruleForm1.achievement = '';
      this.ruleForm1.sale_commision = '';
    },
    // 编辑电订单
    editOrder: function editOrder() {
      var _this18 = this;
      if (this.orderInfo.card_bin_group_id == 6 && this.orderInfo.audit_status == 5 && this.orderInfo.is_return_money != this.ruleForm.is_return_money) {
        this.submitLoading = false;
        this.$message.error('订单确认后不可修改是否回款');
        return false;
      }
      // can_change_type 0已售卡不可修改  1未售卡可修改（sale_type售卡类型  send_type发放类型）
      if ((this.orderInfo.sale_type != this.ruleForm.sale_type || this.orderInfo.selected_send_type != this.ruleForm.send_type) && this.orderInfo.can_change_type == 0) {
        this.$message.error('订单已售卡不可修改售卡类型/发放类型');
        this.submitLoading = false;
        return false;
      }
      var params = _objectSpread({}, this.ruleForm);
      params.order_id = this.order_id;
      params.target_cost_rate = params.the_loser_id ? params.target_cost_rate : '';
      // return
      if (this.orderInfo.finance_money == 0 && this.orderInfo.settlement_type == 1 && this.ruleForm.settlement_type == 2 && (Number(this.invalidAchievement) > 0 || Number(this.validAchievement) > 0)) {
        this.$confirm('<span style="color: red">订单存在有效期业绩奖励，设置按消费结算后将自动清零，是否继续</span>', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(function () {
          _editOrder(params).then(function (res) {
            _this18.$message.success('编辑成功');
            if (_this18.isDrawer) {
              _this18.$emit('onSuccess');
            } else {
              _this18.$router.go(-1);
            }
          }).finally(function () {
            _this18.submitLoading = false;
          });
        }).catch(function () {
          _this18.$message.info('已取消');
          _this18.submitLoading = false;
        });
      } else {
        _editOrder(params).then(function (res) {
          _this18.$message.success('编辑成功');
          if (_this18.isDrawer) {
            _this18.$emit('onSuccess');
          } else {
            _this18.$router.go(-1);
          }
        }).finally(function () {
          _this18.submitLoading = false;
        });
      }
    }
  }
};